import { Reveal, ChapterLabel } from "./Reveal";

export const Footer = () => (
  <footer
    id="contact"
    data-testid="contact-footer"
    className="relative overflow-hidden bg-[#12293F] text-[#FAF7F2]"
  >
    <div
      className="hero-ring"
      style={{ width: 560, height: 560, right: "-12%", top: "-48%", opacity: 0.22 }}
      aria-hidden="true"
    />
    <div
      className="hero-ring"
      style={{ width: 400, height: 400, right: "-6%", top: "-30%", opacity: 0.3 }}
      aria-hidden="true"
    />
    <div
      className="hero-ring"
      style={{ width: 240, height: 240, right: "-1%", top: "-14%", opacity: 0.4 }}
      aria-hidden="true"
    />

    <div className="relative z-10 mx-auto max-w-6xl px-6 py-24 lg:px-10 lg:py-32">
      <Reveal>
        <ChapterLabel number="05" label="Contact" dark />
        <h2
          data-testid="contact-title"
          className="font-display mt-6 max-w-2xl text-3xl font-light leading-tight tracking-tight text-[#FAF7F2] sm:text-4xl lg:text-5xl"
        >
          Reach out through the practice most convenient to you
        </h2>
        <p className="mt-6 max-w-xl text-base leading-relaxed text-[#E4D2AA]/80">
          For appointments and enquiries, please contact one of the practice locations directly
          in Kingston, Ocho Rios, or Montego Bay.
        </p>
        <a
          href="#practices"
          data-testid="contact-practices-link"
          className="link-underline mt-10 inline-block text-xs font-semibold uppercase tracking-[0.22em] text-[#C9A66B] transition-colors duration-300 hover:text-[#E4D2AA]"
        >
          View practice locations
        </a>
      </Reveal>

      <div className="mt-20 flex flex-col gap-6 border-t border-[#C9A66B]/20 pt-10 sm:flex-row sm:items-end sm:justify-between">
        <span
          data-testid="footer-wordmark"
          className="font-script text-3xl leading-none text-[#E4D2AA]"
        >
          Valence A Jordan
        </span>
        <p className="text-[12.5px] tracking-wide text-[#FAF7F2]/40">
          Consultant Ophthalmologist · Glaucoma &amp; Complex Cataract Surgery · Jamaica
        </p>
      </div>
    </div>
  </footer>
);
